import React, { useEffect, useRef, useState } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import {
  addVendor,
  listVendor,
  vendorDetails,
  editVendor,
  deleteVendor,
} from "../../../services/vendor.services";
import {
  LOADER_TIMEOUT_TIME,
  SORT_A,
  SORT_D,
  SWAL_SETTINGS,
} from "../../../../../utils/Constants";

import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import {
  capitalizeFirstLetter,
  globalLoader,
  handleOffcanvasScroll,
  handleServerValidations,
  useDebouncing,
  writeMyExcel,
} from "../../../../../utils/commonfunction";
import ManagementToolbar from "../../../shared/components/ManagementToolbar";
import ResponsiveDataTable from "../../../shared/components/ResponsiveDataTable";
import TableActionDropdown from "../../../shared/components/TableActionDropdown";
import CustomError from "../../../../../utils/customError";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RecordNotFound from "../../../shared/recordNotFound";
import { Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../../admin/common/custompagination";
import logo from "../../../../../assets/restaurant/images/calenderLogo.png";

const CustomBase64Caret = () => (
  <img src={logo} alt="Custom Caret" style={{ width: 20, height: 20 }} />
);

export default function VendorManagement() {
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const itemPerPage = 10;
  const location = useLocation();
  const { t } = useTranslation();
  const [List, setList] = useState([]);
  const { addVendorValidationSchema } = useValidationSchemas();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const { table_id } = location.state || {};
  const { i18n } = useTranslation();

  // State for search input and select dropdown
  const [searchValue, setSearchValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [sortConfig, setSortConfig] = useState({
    column: "createdAt",
    order: SORT_D,
  });
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [vendorDetail, setVendorDetail] = useState({});
  const [openVendorEdit, setOpenVendorEdit] = useState(false);
  const vendorComponentRef = useRef();

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const prepareGlobalSearch = (value) => {
    setPrevGlobalSearch(globalSearch);
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  const handleFilterStatusChange = (e) => {
    if (e.target.value) {
      prepareSearch("status", e.target.value);
    } else {
      prepareSearch("status", "");
    }
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    searchDebounce(value);
  };

  // Handle select dropdown change
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value);
    handleFilterStatusChange(e);
  };

  useEffect(() => {
    setLoader(true);

    const formData = new FormData();

    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify(search));
    }

    formData.append("global_search", globalSearch);
    formData.append("page", page);
    formData.append("per_page", itemPerPage);

    if (sortConfig) {
      formData.append("sort", JSON.stringify(sortConfig));
    }

    listVendor(formData)
      .then((data) => {
        if (data && data.data) {
          setList(data.data.list || []);
          setOffsetPage(data.data.offset || 0);
          setTotalRecords(data.data.total_records || 0);
        } else {
          setList([]);
          setOffsetPage(0);
          setTotalRecords(0);
        }

        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.log("Vendor list error ====> ", error);
        setLoader(false);
      });
  }, [page, globalSearch, sortConfig, refreshList, search]);

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const handleSort = (key) => {
    let direction = SORT_A;
    if (sortConfig.column === key && sortConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortConfig({ column: key, order: direction });
  };

  const getVendorDetail = (item) => {
    vendorDetails({ vendor_id: item._id })
      .then((response) => {
        editForm.setValues({
          vendor_id: response?.data?._id || "",
          companyName: response?.data?.companyName.toLowerCase() || "",
          contactPersonName: response?.data?.contactPersonName || "",
          telephoneNumber: response?.data?.telephoneNumber || "",
          email: response?.data?.email || "",
          address: response?.data?.address || "",
          notes: response?.data?.notes || "",
          status: response?.data?.status || "",
        });

        setVendorDetail(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteVendorRecord = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);

        deleteVendor({ o_id: item._id })
          .then((response) => {
            globalLoader(false);

            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setOpenWithHeader(false);
              setPage(1);
              setSortConfig({ column: "createdAt", order: SORT_D });
              setRefreshList(!refreshList); // refresh list
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteVendorError", error);
          });
      }
    });
  };

  const addForm = useFormik({
    initialValues: {
      companyName: "",
      contactPersonName: "",
      telephoneNumber: "",
      email: "",
      address: "",
      status: "active",
      notes: "",
    },

    validationSchema: addVendorValidationSchema,

    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,

    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("companyName", values.companyName.toLocaleLowerCase());
      formData.append("contactPersonName", values.contactPersonName);
      formData.append("telephoneNumber", values.telephoneNumber);
      formData.append("email", values.email);
      formData.append("address", values.address);
      formData.append("status", values.status);
      formData.append("notes", values.notes);

      setAddSubmissionLoader(true);

      addVendor(formData)
        .then((response) => {
          setAddSubmissionLoader(false);

          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });

            resetForm();
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error adding vendor", error);
        });
    },
  });

  const editForm = useFormik({
    initialValues: {
      vendor_id: "",
      companyName: "",
      contactPersonName: "",
      telephoneNumber: "",
      email: "",
      address: "",
      notes: "",
      status: "",
    },

    validationSchema: addVendorValidationSchema,

    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,

    onSubmit: (values, { resetForm }) => {
      editVendor(values)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });

            resetForm();
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          console.error("Error updating vendor", error);
        });
    },
  });

  const handleVendorExportToExcel = () => {
    if (!List || List.length === 0) return;

    const headers = [
      t("label_vendor_company_name"),
      t("label_vendor_manager"),
      t("label_vendor_telephone_number"),
      t("label_vendor_email"),
      t("label_vendor_address"),
      t("label_vendor_note"),
      t("label_vendor_status"),
    ];

    const rows = List.map((item) => [
      item?.companyName || "-",
      item?.contactPersonName || "-",
      item?.telephoneNumber || "-",
      item?.email || "-",
      item?.address || "-",
      item?.notes || "-",
      item?.status === "active"
        ? t("vendor_label_active")
        : t("vendor_label_deactive"),
    ]);

    writeMyExcel([headers, ...rows], `${t("label_vendor_list_export")}.xlsx`);
  };


  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">
            {t("label_vendor_management")} ({totalRecords})
          </h4>
        </div>
        <ManagementToolbar search={<div className="search-box">
            <input
              type="text"
              value={searchValue}
              className="form-control search-input"
              placeholder={t("input_placeholder_search")}
              onChange={handleSearchChange}
            />
          </div>}>
            <div className="tabls-dowpdown">
              <select
                className="form-control cp"
                onChange={handleSelectChange}
                defaultValue=""
              >
                <option value="">{t("label_all")}</option>

                <option value="active">{t("vendor_label_active")}</option>

                <option value="deactive">{t("vendor_label_deactive")}</option>
              </select>
            </div>


            <button
              className="btn btn-primary vendor-registration-btn restaurant-toolbar-action"
              onClick={() => {
                setOpenWithHeader(true);
              }}
            >
              <i className="ti ti-plus"></i> {t("label_make_vendor")}
            </button>
            <button
              className="btn btn-primary restaurant-toolbar-action vendor-export-btn"
              onClick={handleVendorExportToExcel}
              disabled={!List || List.length === 0}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H11.5M14 3L19 8M19 8V13M14 19H21M21 19L18 16M21 19L18 22"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>{" "}
              {t("label_export")}
            </button>
        </ManagementToolbar>
        <div className="page-header d-flex align-items-center">
          <h6 className="heading-title-text">{t("label_vendor_list")}</h6>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : List?.length ? (
              <div className="card">
                <div className="card-body">
                  <ResponsiveDataTable>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            {t("label_vendor_company_name")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("companyName")}
                            >
                              <i
                                className={`${sortConfig.column === "companyName" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "companyName" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>
                            {t("label_vendor_manager")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("contactPersonName")}
                            >
                              <i
                                className={`${sortConfig.column === "contactPersonName" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "contactPersonName" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>
                            {t("label_vendor_telephone_number")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("telephoneNumber")}
                            >
                              <i
                                className={`${sortConfig.column === "telephoneNumber" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "telephoneNumber" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>
                            {t("label_vendor_email")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("email")}
                            >
                              <i
                                className={`${sortConfig.column === "email" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "email" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>
                            {t("label_vendor_address")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("address")}
                            >
                              <i
                                className={`${sortConfig.column === "address" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "address" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>
                            {t("label_vendor_note")}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSort("notes")}
                            >
                              <i
                                className={`${sortConfig.column === "notes" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "5px" }}
                              ></i>
                              <i
                                className={`${sortConfig.column === "notes" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                style={{ marginLeft: "-8px" }}
                              ></i>
                            </span>
                          </th>

                          <th>{t("list_heading_status")}</th>

                          <th style={{ width: "150px" }}>
                            {t("label_action")}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {List.map((item, index) => {
                          return (
                            <tr key={item._id}>
                              <td>{capitalizeFirstLetter(item?.companyName) || "-"}</td>

                              <td className="text-capitalize">
                                {item?.contactPersonName || "-"}
                              </td>

                              <td>{item?.telephoneNumber || "-"}</td>

                              <td>{item?.email || "-"}</td>

                              <td>{capitalizeFirstLetter(item?.address) || "-"}</td>

                              <td>{capitalizeFirstLetter(item?.notes) || "-"}</td>

                              <td>
                                <span
                                  className={`status-badge d-block ${item?.status === "active"
                                    ? "status-badge-success"
                                    : "status-badge-danger"
                                    }`}
                                  style={{ width: "max-content" }}
                                >
                                  {item?.status === "active"
                                    ? t("vendor_label_active")
                                    : t("vendor_label_deactive")}
                                </span>
                              </td>

                              <td className="">
                                <TableActionDropdown>
                                    {/* View Vendor Details */}
                                    <li>
                                      <a
                                        className="dropdown-item cp"
                                        onClick={() => getVendorDetail(item)}
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#view-staff"
                                      >
                                        <i className="ti ti-eye"></i>
                                        {t("btn_view")}
                                      </a>
                                    </li>

                                    {/* Edit Vendor */}
                                    <li>
                                      <a
                                        className="dropdown-item cp"
                                        onClick={() => {
                                          getVendorDetail(item);
                                          setOpenWithHeaderEdit(true);
                                        }}
                                      >
                                        <i className="ti ti-edit"></i>
                                        {t("btn_edit")}
                                      </a>
                                    </li>

                                    {/* Delete Vendor */}
                                    <li>
                                      <a
                                        className="dropdown-item cp text-danger"
                                        onClick={() => deleteVendorRecord(item)}
                                      >
                                        <i className="ti ti-trash"></i>
                                        {t("btn_delete")}
                                      </a>
                                    </li>
                                </TableActionDropdown>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </ResponsiveDataTable>
                  <div className="table-status-info d-flex justify-content-between align-items-center">
                    <span>
                      {t("label_showing_entries", { shown: offset + List.length, total: totalRecords })}
                    </span>
                    <nav aria-label="Page navigation example" title={page}>
                      {totalRecords > itemPerPage ? (
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[
                            {
                              name: "vendors",
                              path: "/restaurant/order-management/vendor-management/list",
                            },
                          ]}
                        />
                      ) : (
                        ""
                      )}
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_vendors_found" />
            )}
          </div>
        </div>
        <div></div>
      </div>

      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_vendor_registration")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeader(false);
                addForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editNewEmail", "rsuite");
          }}
        >
          <form onSubmit={addForm.handleSubmit} noValidate>
            {/* Company Name */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_company_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("label_vendor_company_name")}
                name="companyName"
                value={addForm?.values?.companyName}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError
                name="companyName"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Contact Person Name */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_cendor_contact_person_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("label_cendor_contact_person_name")}
                name="contactPersonName"
                value={addForm?.values?.contactPersonName}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError
                name="contactPersonName"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Telephone Number */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_telephone_number")}
                <span>*</span>
              </label>
              <input
                type="number"
                className="form-control"
                placeholder={t("label_vendor_telephone_number")}
                name="telephoneNumber"
                value={addForm?.values?.telephoneNumber}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
                maxLength={10}
              />
              <CustomError
                name="telephoneNumber"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Email Address */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_email")}
                <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder={t("label_vendor_email")}
                name="email"
                value={addForm?.values?.email}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError
                name="email"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Address */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_address")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                rows="3"
                placeholder={t("label_vendor_address")}
                name="address"
                value={addForm?.values?.address}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError
                name="address"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Status */}
            {/* <div className="mb-3">
              <label className="form-label">{t("label_vendor_status")}</label>

              <select
                className="form-control cp"
                name="status"
                value={addForm?.values?.status || ""}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              >
                <option disabled value="">
                  {t("input_select_text")}
                </option>

                <option value="active">{t("vendor_label_active")}</option>

                <option value="deactive">{t("vendor_label_deactive")}</option>
              </select>

              <CustomError
                name="status"
                form={addForm}
                className="text-danger"
              />
            </div> */}

            {/* Notes */}
            <div className="mb-3">
              <label className="form-label">{t("label_vendor_note")}</label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                rows="3"
                placeholder={t("label_vendor_note")}
                name="notes"
                value={addForm?.values?.notes}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError
                name="notes"
                form={addForm}
                className="text-danger"
              />
            </div>

            {/* Submit Button */}
            <div className="button-form">
              <button
                type="submit"
                className={
                  "btn btn-primary w-100" +
                  (addSubmissionLoader ? " btn-loader" : "")
                }
              >
                {t("label_vendor_save")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_edit_vendor")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderEdit(false);
                editForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>

        <Drawer.Body>
          <form onSubmit={editForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_company_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("label_vendor_company_name")}
                name="companyName"
                value={editForm?.values?.companyName}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="companyName"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Contact Person Name */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_cendor_contact_person_name")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("label_cendor_contact_person_name")}
                name="contactPersonName"
                value={editForm?.values?.contactPersonName}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="contactPersonName"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Telephone Number */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_telephone_number")}
                <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("label_vendor_telephone_number")}
                name="telephoneNumber"
                value={editForm?.values?.telephoneNumber}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="telephoneNumber"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Email Address */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_email")}
                <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder={t("label_vendor_email")}
                name="email"
                value={editForm?.values?.email}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="email"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Address */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_vendor_address")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder={t("label_vendor_address")}
                name="address"
                value={editForm?.values?.address}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="address"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Status */}
            <div className="mb-3">
              <label className="form-label">{t("label_vendor_status")}</label>

              <select
                className="form-control cp"
                name="status"
                value={editForm?.values?.status || ""}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              >
                <option disabled value="">
                  {t("input_select_text")}
                </option>

                <option value="active">{t("vendor_label_active")}</option>

                <option value="deactive">{t("vendor_label_deactive")}</option>
              </select>

              <CustomError
                name="status"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Notes */}
            <div className="mb-3">
              <label className="form-label">{t("label_vendor_note")}</label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                rows="3"
                placeholder={t("label_vendor_note")}
                name="notes"
                value={editForm?.values?.notes}
                onChange={editForm.handleChange}
                onBlur={editForm.handleBlur}
              />
              <CustomError
                name="notes"
                form={editForm}
                className="text-danger"
              />
            </div>

            {/* Submit */}
            <div className="button-form">
              <button type="submit" className="btn btn-primary w-100">
                Update
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      <div
        className="offcanvas offcanvas-end right-modal-w"
        id="view-staff"
        data-bs-backdrop="static"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            {t("vendor_details")}
          </h5>
          <button
            type="button"
            className="btn btn-icon ms-auto"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="view-staff-info">
            <div className="row gap-4">
              <div className="col-md-12">
<h4>{t("label_vendor_company_name")}</h4>
                <p>
                  {vendorDetail?.companyName
                    ? vendorDetail.companyName
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
                <h4>{t("label_contact_person_name")}</h4>
                <p>
                  {vendorDetail?.contactPersonName
                    ? vendorDetail.contactPersonName
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
                <h4>{t("label_telephone_number")}</h4>
                <p>
                  {vendorDetail?.telephoneNumber
                    ? vendorDetail.telephoneNumber
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
                <h4>{t("label_vendor_email")}</h4>
                <p>
                  {vendorDetail?.email
                    ? vendorDetail.email
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
<h4>{t("label_vendor_address")}</h4>
                <p>
                  {vendorDetail?.address
                    ? vendorDetail.address
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
                <h4>{t("label_notes")}</h4>
                <p>
                  {vendorDetail?.notes
                    ? vendorDetail.notes
                    : t("label_not_entered")}
                </p>
              </div>

              <div className="col-md-12">
                <h4>{t("label_status")}</h4>
                <p>
                  {vendorDetail?.status === "active"
                    ? t("vendor_label_active")
                    : t("vendor_label_deactive")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
